module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('draggable', {
    staticClass: "list-group dragArea",
    attrs: {
      "tag": "ul",
      "list": _vm.fieldTypes,
      "sort": false,
      "group": {
        name: 'components',
        pull: 'clone',
        put: false
      },
      "clone": _vm.onClone
    },
    on: {
      "start": function($event) {
        return _vm.$emit('drag-started')
      }
    }
  }, _vm._l((_vm.fieldTypes), function(component, index) {
    return _c('li', {
      key: 'item-list-key' + index,
      staticClass: "list-group-item col-md-12"
    }, [_c('i', {
      class: _vm.icons[component.type]
    }), _vm._v(" " + _vm._s(component.label) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-499ba5f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/VueFormBuilderFieldList.vue
// module id = 1631
// module chunks = 1